import { donationConstants, apiConstants } from '../constants';
import url from '../../helpers/url';

export const saveDonation = (form) => ({
    type: apiConstants.API,
    payload: {
        url: form.id ?
            url.donation.replace(':donorId', form.donorId).replace(':donationId', form.id) :
            url.donations.replace(':donorId', form.donorId),
        method: 'POST',
        body: form,
        request: () => ({ type: donationConstants.SAVING_DONATION_REQUEST }),
        success: (data) => ({ type: donationConstants.SAVING_DONATION_SUCCESS, data }),
        failure: (error) => ({ type: donationConstants.SAVING_DONATION_FAILURE, error }),
        formatData: (data) => ({ form: { ...data[0]} }),
        progress: {
            success: { message: () => 'Saved Donation.' }
        }
    }
});

export const deleteDonation = ({ donorId, donationId }) => ({
    type: apiConstants.API,
    payload: {
        url: url.donation.replace(':donorId', donorId).replace(':donationId', donationId),
        method: 'DELETE',
        request: () => ({ type: donationConstants.DELETE_DONATION_REQUEST }),
        success: (data) => ({ type: donationConstants.DELETE_DONATION_SUCCESS, data }),
        failure: (error) => ({ type: donationConstants.DELETE_DONATION_FAILURE, error }),
        formatData: () => (donationId),
        progress: {
            request: { message: () => 'Deleting donation...' },
            success: { message: () => 'Deleted donation.' }
        }
    }
});

export const loadDonations = (id) => ({
    type: apiConstants.API,
    payload: {
        url: url.donations.replace(':donorId', id),
        request: () => ({ type: donationConstants.LOAD_DONATION_REQUEST }),
        success: (data) => ({ type: donationConstants.LOAD_DONATION_SUCCESS, data }),
        failure: (error) => ({ type: donationConstants.LOAD_DONATION_FAILURE, error })
    }
});


// WEBPACK FOOTER //
// ./src/redux/actions/donation.actions.js